<template>
  <div class="btn-group btn-group-sm">
    <button @click="verMovimiento" class="btn btn-primary">
      Ver Movimiento
    </button>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "MovimientosTablaActions",
  methods: {
    verMovimiento() {
      this.$store.dispatch(
        "Movimientos/setMovimientoAVisualizar",
        this.params.data,
      );

      setTimeout(() => this.$bvModal.show("verMovimientoModal"), 0);
    },
  },
});
</script>

<style scoped></style>
